/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Alert } from "react-bootstrap";
// <a
//   href={`${
//     process.env.PUBLIC_URL
//   }/templates/RunsheetUploadTemplate.xlsx`}
//   download
// >
//   download
// </a>{" "}
// // error response example:
// {
//   "feedback" : "798ef480-e3b8-44be-ad90-d36b5acfa5eb",
//   "errors" : [ {
//     "column" : 1,
//     "details" : "Job ID is missing",
//     "row" : 1
//   } ]
// }
const Error = props => {
  const { errors, feedback } = props;

  return (
    <Alert bsStyle="danger" className="custom-alert">
      <p>There are some validation issues with given Excel file:</p>
      <ul>
        {errors.map(e => (<li>{e.details}</li>))}
      </ul>
      <br />
      <p>You can download a new Excel file with your previous data along with highlighting and feedback on what needs to be addressed for a successful upload</p>
      <p>
        <a
          href={`${
            process.env.REACT_APP_RUNSHEETS_API
          }runsheets/upload/${feedback}`}
          download
        >
          Download workbook
        </a>
      </p>
    </Alert>
  );
};
Error.propTypes = {
  errors: PropTypes.array.isRequired,
  feedback: PropTypes.string.isRequired
};

export default Error;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/upload/Error.js